<template>
    <a-config-provider
        :locale="zhCN"
        :theme="{
            token: {
                colorPrimary: '#007FF6'
            }
        }"
    >
        <router-view />
    </a-config-provider>
</template>
<script setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import 'dayjs/locale/zh-cn.js'
</script>
<style lang="less">
@import './assets/css/base.less';
</style>
<style lang="less" scoped></style>
